<template>
    <div class="staff my-10 px-2">
      <div class="d-flex align-end mb-4" :style="{ position: 'relative' }">
        <div class="text-center">
          <span class="overline"> New </span>
          <div>
            <v-btn
              min-width="42px"
              height="38px"
              class="px-0"
              color="secondary"
              :loading="showTableLoader"
              @click="handleWorkflowForm({})"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </div>
  
        <!-- filters -->
        <div class="d-flex" :class="laptopSmaller ? 'align-end' : 'align-center'">
          <div class="ml-3 text-center">
            <span class="overline"> Clear </span>
            <div>
              <v-btn
                min-width="42px"
                height="38px"
                class="px-0"
                color="secondary"
                :loading="showTableLoader"
                @click="clearFilters()"
              >
                <v-icon>mdi-filter-remove</v-icon>
              </v-btn>
            </div>
          </div>
  
          <v-dialog
            class="staff__modal"
            max-width="1200"
            v-model="workflowModalStatus"
            persistent
          >
            <WorkflowModal
              :isOperating="workflowModalStatus"
              :itemToEdit="itemToEdit"
              :profileView="false"
              @close-form="closeWorkflowForm"
              @refresh-data="handleRefresh"
              @close-expanded-items="closeExpandedItems"
            />
          </v-dialog>
        </div>

        <!-- Project filter -->
        <div class="ml-2 text-center">
          <span class="overline"> Project </span>
          <div>
            <v-autocomplete
              class="assignment-dashboard__project-selector popup selector"
              :items="projectsList"
              item-text="name"
              item-value="id"
              v-model="filterProject"
              solo
              dense
              hide-details
              :disabled="showTableLoader"
              :loading="showTableLoader"
              @input="handleFilterQuery('projectId', $event)"
            ></v-autocomplete>
          </div>
        </div>

        <!-- GEO filter -->
        <div class="ml-2 text-center">
          <span class="overline"> GEO </span>
          <div>
            <v-autocomplete
              class="assignment-dashboard__geo-selector popup selector"
              :items="geoOptions"
              v-model="filterGeo"
              style="width:100px;"
              solo
              dense
              hide-details
              :disabled="showTableLoader"
              :loading="showTableLoader"
              @input="handleFilterQuery('Geo', $event)"
            ></v-autocomplete>
          </div>
        </div>

        <!-- request type filter -->
        <div class="ml-2 text-center">
          <span class="overline"> Request Type </span>
          <div>
            <v-autocomplete
              class="assignment-dashboard__request-selector popup selector"
              style="width: 220px;"
              :items="requestTypeOptions"
              v-model="filterRequestType"
              solo
              dense
              hide-details
              :disabled="showTableLoader"
              :loading="showTableLoader"
              @input="handleFilterQuery('RequestType', $event)"
            ></v-autocomplete>
          </div>
        </div>

        <!-- media type filter -->
        <div class="ml-2 text-center">
          <span class="overline"> Media Type </span>
          <div>
            <v-autocomplete
              class="assignment-dashboard__media-selector popup selector"
              style="width: 220px;"
              :items="mediaTypeOptions"
              v-model="filterMediaType"
              solo
              dense
              hide-details
              :disabled="showTableLoader"
              :loading="showTableLoader"
              @input="handleFilterQuery('MediaType', $event)"
            ></v-autocomplete>
          </div>
        </div>

        <!-- Keyword filter -->
        <div class="ml-2 text-center">
          <span class="overline"> Keyword </span>
          <div>
            <v-autocomplete
              class="assignment-dashboard__media-selector popup selector"
              style="width: 220px;"
              :items="keywordOptions"
              v-model="filterKeyword"
              solo
              dense
              hide-details
              :disabled="showTableLoader"
              :loading="showTableLoader"
              @input="handleFilterQuery('keyword', $event)"
            ></v-autocomplete>
          </div>
        </div>
  
        <!-- right -->
        <!-- <div class="ml-auto">
          <v-text-field
            v-model="search"
            style="width: 290px;"
            class="staff__search-selector selector"
            append-outer-icon="mdi-magnify"
            solo
            dense
            hide-details
            clearable
            :loading="showTableLoader"
            :disabled="showTableLoader"
            @click:append-outer="applySearch(search)"
            @click:clear="applySearch('')"
            @keydown.enter="applySearch(search)"
          />
        </div> -->
      </div>
      <!-- table -->
      <v-card>
        <v-skeleton-loader
          v-if="showTableLoader"
          type="table"
          height="100vh"
        ></v-skeleton-loader>
        <!-- <WorkflowTable
          v-if="gWorkflowData.length"
          :tableData="gWorkflowData"
          @call-edit-form="handleForm"
        /> -->
        <WorkflowNewTable
          :closeExpandedItems="closeExpandedItemsValue"
          @call-edit-form="handleForm"
        />
      </v-card>
    </div>
  </template>
  
  <script>
  // vuex
  import { mapGetters, mapActions } from "vuex";
  // libraries
  import _ from "lodash";
  // internal
  import {
    getAllStaff,
    getLimitedStaffWithNameAndGeos,
    getEnumValues,
    getAllProjects,
    getAllProjectsWithWorkflowsData
  } from "@/utils/newDbUtils";
  import { customBreakpoint, timeUnits } from "@/utils/mixins";
  // components
  import WorkflowNewTable from "@/components/Workflows/WorkflowNewTable";
  import WorkflowModal from "@/components/Workflows/WorkflowModal";
  
  export default {
    name: "Workflows",
    components: {
        WorkflowNewTable,
        WorkflowModal,
    },
    data() {
      return {
        showTableLoader: false,
        expandMenu: false,
        dropdownsLoading: true,
        statusOptions: [],
        workflowModalStatus: false,
        itemToEdit: {},
        filterProject: null,
        filtersDialog: false,
        filtersBadge: false,
        search: "",
        filterRequestType: null,
        filterGeo: null,
        filterMediaType: null,
        filterKeyword: null,
        closeExpandedItemsValue: 0,
      };
    },
    computed: {
      ...mapGetters("auth", ["user", "isAdmin"]),
      ...mapGetters("workflow", [
        "gWorkflowData",
        "gWorkflowResponseTotalElements",
        "gWorkflowTablePage",
        "gWorkflowTableSize"
      ]),
      ...mapGetters("staff", ["gStaffList"]),
      ...mapGetters("assignment", ["requestTypeOptions", "geoOptions", "mediaTypeOptions", "keywordOptions", "projectsList"]),
    },
    mixins: [customBreakpoint, timeUnits],
    methods: {
      ...mapActions("assignment", ["setCommonData"]),
      ...mapActions("staff", ["aGetAllStaff"]),
      ...mapActions("workflow", [
        "aUpdateFormData",
        "aClearWorkflow",
        "aSetIfUpdated",
        "aSaveNewWorkflowClone",
      ]),
      closeExpandedItems() {
        this.closeExpandedItemsValue = this.closeExpandedItemsValue + 1;
      },
        handleRefresh() {
            this.staffModal = false
        },
        handleWorkflowForm(tableRow) {
            this.itemToEdit = { ...tableRow };
            this.workflowModalStatus = true;
        },
        async handleDropdowns() {
            let dropdowns = [
              getAllProjectsWithWorkflowsData(this.$route.query),
              getEnumValues("geos", "key"),
              getEnumValues("request-types"),
              getEnumValues("media-types"),
              getEnumValues("keywords")
            ];
            await Promise.all(dropdowns)
            .then((resp) => {
                let newProjects = resp[0].data;
                newProjects.forEach((project) => {
                  project.staff.forEach((staffEl) => {
                    let originalStaff = this.gStaffList.find((item) => item.user.id === staffEl.user.id);
                    staffEl.adminDetails = originalStaff.adminDetails;
                  })
                })
                this.setCommonData({ field: "projectsList", data: resp[0].data });
                this.setCommonData({ field: "geoOptions", data: resp[1] });
                this.setCommonData({ field: "requestTypeOptions", data: resp[2] });
                this.setCommonData({ field: "mediaTypeOptions", data: resp[3] });
                this.setCommonData({ field: "keywordOptions", data: resp[4] });
            })
            .catch((err) => {
                console.error(err);
            });
        },
        handleForm(tableRow) {
            this.aSetIfUpdated(true);
            this.aUpdateFormData(tableRow);
            this.aSaveNewWorkflowClone();
            this.workflowModalStatus = true;
        },
        closeWorkflowForm() {
            this.itemToEdit = {};
            this.aClearWorkflow();
            this.aSetIfUpdated(false);
            this.workflowModalStatus = false;
        },
        applySearch(search) {
          this.handleFilterQuery("workflowName", search);
        },
        async handleFilterQuery(param, data) {
          this.showTableLoader = true;

          const query = { ...this.$route.query };

          if (data === null) {
            delete query[param];
          } else {
            query[param] = data;
          }

          this.$router
            .push({
              path: `/workflows`,
              query,
            })
            .catch(() => {});

          const resp = await getAllProjectsWithWorkflowsData(query);
          const newProjects = resp.data;
          newProjects.forEach((project) => {
            project.staff.forEach((staffEl) => {
              let originalStaff = this.gStaffList.find((item) => item.user.id === staffEl.user.id);
              if (originalStaff) {
                staffEl.adminDetails = originalStaff.adminDetails;
              }
            });
          });

          this.setCommonData({ field: "projectsList", data: resp.data });
          this.closeExpandedItems();
          this.showTableLoader = false;
        },
        async clearFilters() {
          this.showTableLoader = true;
          let query = {};
          this.filterProject = null;
          this.filterRequestType = null;
          this.filterGeo = null;
          this.filterMediaType = null;
          this.search = "";
          this.$router
            .push({
              path: `/workflows`,
              query: query,
            })
            .catch(() => {});
            const resp = await getAllProjectsWithWorkflowsData(query);
            const newProjects = resp.data;
            newProjects.forEach((project) => {
              project.staff.forEach((staffEl) => {
                let originalStaff = this.gStaffList.find((item) => item.user.id === staffEl.user.id);
                staffEl.adminDetails = originalStaff.adminDetails;
              })
            })
            this.setCommonData({ field: "projectsList", data: resp.data });
            this.closeExpandedItems();
            this.showTableLoader = false;
        },
    },
    async mounted() {
      this.showTableLoader = true;
      this.$route.query.RequestType ? this.filterRequestType = this.$route.query.RequestType : null;
      this.$route.query.Geo ? this.filterGeo = this.$route.query.Geo : null;
      this.$route.query.MediaType ? this.filterMediaType = this.$route.query.MediaType : null;
      this.$route.query.keyword ? this.filterKeyword = this.$route.query.keyword : null;
      const resp = await getLimitedStaffWithNameAndGeos();
      const staff = resp.data;
      const newStaffArray = staff.map((el) => {
        const newStaffObj = {
          user: {
            firstName: el.firstName,
            lastName: el.lastName,
            id: el.id,
          },
          adminDetails: {
            activeStaff: el.activeStaff,
            geos: el.geos,
          }
        }
        return newStaffObj;
      });
      this.aGetAllStaff(newStaffArray);
      await this.handleDropdowns();
      this.showTableLoader = false;
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .staff {
    max-width: 1500px;
    margin: 0 auto;
  
    &__date-selector {
      width: 220px;
    }
  
    &__language-selector {
      width: 200px;
    }
  
    &__country-selector {
      width: 280px;
    }
  
    &__search-selector {
      width: 450px;
    }
  }
  
  ::v-deep {
    .selector.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
      > .v-input__control
      > .v-input__slot {
      padding-right: 0;
    }
    .selector.v-text-field.v-text-field--solo .v-input__append-inner {
      padding-left: 0;
    }
    .selector.v-autocomplete.v-select.v-input--is-focused input {
      min-width: 0;
    }
    .selector.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
      padding: 2px 0;
    }
    .v-dialog--active {
      position: relative;
    }
    .filters {
      position: absolute;
      top: 20px;
    }
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }
  
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }
  .v-enter,
  .v-leave-to {
    opacity: 0;
  }
  
  .selector-width-2l {
    width: 200px;
  }
  
  .staff__search-selector-2l {
    width: 290px !important;
  }
  
  @import "~vuetify/src/styles/settings/_variables";
  
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    .v-application .overline {
      font-size: 0.6rem !important;
    }
  }
  </style>
  
